// @flow

export const FETCH_MESSAGES: string = 'FETCH_MESSAGES';
export const FETCH_MESSAGES_SUCCESS: string = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE: string = 'FETCH_MESSAGES_FAILURE';
export const FETCH_NEW_MESSAGES_SUCCESS: string = 'FETCH_NEW_MESSAGES_SUCCESS';
export const FETCH_PREVIOUS_MESSAGES: string = 'FETCH_PREVIOUS_MESSAGES';
export const FETCH_PREVIOUS_MESSAGES_PENDING: string =
  'FETCH_PREVIOUS_MESSAGES_PENDING';
export const FETCH_PREVIOUS_MESSAGES_SUCCESS: string =
  'FETCH_PREVIOUS_MESSAGES_SUCCESS';
export const FETCH_PREVIOUS_MESSAGES_FAILURE: string =
  'FETCH_PREVIOUS_MESSAGES_FAILURE';
export const SEND_MESSAGE: string = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS: string = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE: string = 'SEND_MESSAGE_FAILURE';

export const fetchMessages = (thread: string) => ({
  type: FETCH_MESSAGES,
  thread,
});

export const fetchPreviousMessages = (
  thread: string,
  scrollHeight: number
) => ({
  type: FETCH_PREVIOUS_MESSAGES,
  thread,
  scrollHeight,
});

export const sendMessage = (
  thread: string,
  content: string,
  files: Array<File>
) => ({
  type: SEND_MESSAGE,
  thread,
  content,
  files,
});



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/messages.js